export const IMAGE_ITEMS_MOCK_FUNC = (amount) => {
    const imageList:any = [];

    for (let i = 0; i < amount; i++) {
        imageList.push({
            title: `test${i}.jpg`,
            url: ''
        });
    }

    return imageList;
};

export const IMAGE_ITEMS_MOCK = IMAGE_ITEMS_MOCK_FUNC(20);


export const square_box_sizes = { sm: '100%', md: '100%', lg: '100%', xl: '100%' };

export const default_square_box_sizes_sizes = { sm: 90, md: 90, lg: 90, xl: 90 };
